import React from 'react';
import { Phone, MapPin, Instagram } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { PHONE_NUMBER, WHATSAPP_NUMBER, OPENING_HOURS, INSTAGRAM_URL } from '../../config/constants';

const Contact = () => {
  return (
    <section id="contact" className="py-20 px-4 bg-zinc-900" data-testid="contact-section">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <Badge className="bg-amber-500 text-black mb-4 px-4 py-1 text-sm">CONTATTI</Badge>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4">
            Vieni a <span className="text-amber-500">trovarci</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-serif font-bold mb-6 text-amber-500">Informazioni</h3>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <MapPin className="text-amber-500 mt-1 flex-shrink-0" size={24} />
                  <div>
                    <div className="font-semibold mb-1">Indirizzo</div>
                    <div className="text-gray-400">Via Tanzini, 41<br />50065 Pontassieve (FI)</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Phone className="text-amber-500 mt-1 flex-shrink-0" size={24} />
                  <div>
                    <div className="font-semibold mb-1">Telefono</div>
                    <a 
                      href={`tel:${PHONE_NUMBER}`} 
                      className="text-gray-400 hover:text-amber-500 transition-colors"
                      data-testid="contact-phone"
                    >
                      +39 331 885 7252
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Instagram className="text-amber-500 mt-1 flex-shrink-0" size={24} />
                  <div>
                    <div className="font-semibold mb-1">Instagram</div>
                    <a 
                      href={INSTAGRAM_URL} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-amber-500 transition-colors"
                      data-testid="contact-instagram"
                    >
                      @rogers_club_barberia
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-8 bg-black border border-amber-500/30 rounded-sm">
                <div className="font-semibold mb-6 text-amber-500 text-2xl">Orari di Apertura</div>
                <div className="space-y-3 text-lg">
                  {OPENING_HOURS.map((item, index) => (
                    <div key={index} className="flex justify-between">
                      <span className="text-gray-400">{item.day}</span>
                      <span className={item.closed ? 'text-gray-500 font-semibold' : 'text-white'}>
                        {item.hours}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <Button 
                onClick={() => window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank')}
                className="bg-amber-500 hover:bg-amber-600 text-black font-semibold px-8 py-6 text-lg rounded-none w-full"
                data-testid="contact-whatsapp-btn"
              >
                Prenota su WhatsApp
              </Button>
              <Button 
                onClick={() => window.location.href = `tel:${PHONE_NUMBER}`}
                variant="outline"
                className="border-2 border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black font-semibold px-8 py-6 text-lg rounded-none w-full"
                data-testid="contact-call-btn"
              >
                <Phone className="mr-2" size={20} />
                Chiama Ora
              </Button>
            </div>
          </div>

          {/* Map */}
          <div className="h-[500px] rounded-sm overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2876.893574265834!2d11.431862776542183!3d43.771569471096794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a56c7b1b1b1b1%3A0x1b1b1b1b1b1b1b1b!2sVia%20Tanzini%2C%2041%2C%2050065%20Pontassieve%20FI%2C%20Italy!5e0!3m2!1sen!2sit!4v1706000000000!5m2!1sen!2sit"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Roger's Club Barberia Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
